import { WizBasePopUp, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { Component, ElementRef, HostListener } from '@angular/core';
import { VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { Model } from 'src/app/model/model';
import packageJson from 'package.json';

@Component({
  selector: 'user-pop',
  templateUrl: './user.pop.html',
})
export class UserPop extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  public static WIDTH: string = '200px';
  public static HEIGHT: string = '200px';

  constructor(public elementRef: ElementRef) {
    super();
  }

    /** sur alimentation du user, affichage de message de bienvenue */
  public get fullUserLabel(): string {
    if (Model.getInstance().connectedUser) {
      return  WizTranslationManager.getInstance().translateKey('$.account.hello.$', [
        Model.getInstance().connectedUser.fullName,
      ]);
    } else {
      return ' ';
    }
  }

    /** nom complet du user */
  public get userLabel(): string {   
    return Model.getInstance().connectedUser?.fullName || '';
  }

  /**
   * Retourne la version de l'application depuis le package.json
   */
  get applicationVersion(): string {
    return packageJson.version;
  }

  /** déclenche une action */
  public do(action: string): void {
    console.log("action", action);
  }




  public show(): void {
  }

  public doAction(action: string): void {

    switch (action) {
      case "support":
        
        break;
      case "help":  

        break;
      case "language":  

        break;
    }
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }


}
